(function(){
'use strict';

scCdnSrc.$inject = ["generateAssetUrl"];
function scCdnSrc(generateAssetUrl) {
  return {
    scope: {
      scCdnSrc: '@'
    },
    link: function link(scope, element) {
      element.attr('src', generateAssetUrl(scope.scCdnSrc));
    }
  };
}

angular.module('classy').directive('scCdnSrc', scCdnSrc);
})();